import { defineMessages } from 'react-intl'

export default defineMessages({
  details: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.details',
    defaultMessage: 'Order details',
  },
  pronunciations: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.pronunciations',
    defaultMessage: 'Pronunciations',
  },
})
